<template>
  <div>
  <v-btn-form v-if="fileItem" :mode="edit" :title="title" @close="cancel()">
    <v-form v-model="valid" ref="form">
    <v-flex v-if="!isEdit">
        <v-card-title style="display: block; overflow-wrap: break-word;">
          <div class="headline" >{{fileItem.docName}}
          </div>
          <v-component :is="renderDepoFileSignature(fileItem)"></v-component>
        </v-card-title>
        <v-card-text style="display: block; overflow-wrap: break-word;">
          <v-flex>
          Cсылка: <b><a :href="getUrl(fileItem.uid)">{{getUrl(fileItem.uid)}}</a></b>
          </v-flex>
          <v-flex >
          Депонировано: <b>{{formats.blank(fileItem.uploaded, formats.formatDateTime)}}</b> (по:&nbsp{{formats.blank(fileItem.deleted, formats.formatDate)}})
          </v-flex>
          <v-flex>
         <span> Депонент:&nbsp<b>{{fileItem.ownerShortName}}</b>
          ИНН:&nbsp<b>{{formats.formatInn(fileItem.ownerInn)}}</b></span>
          </v-flex>
          <v-flex>
           Файл: <b>{{fileItem.fileName}}</b>
          </v-flex>
          <v-flex>
          Размещение: {{getDisplayPath(fileItem.path)}}
          </v-flex>
          <v-flex>
          Примечания: {{fileItem.desc}}
          </v-flex>
          <v-flex>
          Теги: <b>{{fileItem.tags}}</b>
          </v-flex>
          <v-flex v-show="fileItem.prevUid">
            ВАЖНО! Существует
            <a @click="openFile(fileItem.prevUid)">предыдущая версия файла.</a>
          </v-flex>
          <!-- michel 2025-06-27
          <v-flex>
            <b><a :href="getUrl(getOpenSettings.depoRules)">Правила Депонирования</a></b>
          </v-flex>
          -->
        </v-card-text>
        </v-flex>
    </v-flex>
      <v-flex v-show="isEdit">
        <v-card-title style="display: block; overflow-wrap: break-word;">
          <span class="headline">{{fileItem.docName}}</span>
        </v-card-title>
        <v-card-text>
        <v-layout column>
        <v-flex>
          <v-select
            label="Размещение в папке"
            v-model="fileItem.path"
            hint="Структура папок видна только для пользователей депонента"
            :items="getDisplayPaths()"
            item-value="key"
            item-text="value"
          >
          </v-select>
        </v-flex>
        <v-flex>
          <v-textarea
            label="Примечания"
            rows="3"
            hint="Примечания видны только для пользователей депонента"
            v-model="fileItem.desc"
            clearable
          ></v-textarea>
        </v-flex>
        <v-flex>
          <v-textarea
            label="Поисковые теги"
            hint="Поисковые теги используются для поиска по документам депонента"
            rows="1"
            v-model="fileItem.tags"
            clearable
          ></v-textarea>
        </v-flex>
      </v-layout>
      </v-card-text>
    </v-flex>
    </v-form>
    <v-card v-if="!isEdit && (history.length > 1)">
      <v-panel-title @click="isLoaded=!isLoaded" :value="isLoaded" :caption="'Все версии'" :expandable="true">
      </v-panel-title>
      <template v-for="item in history">
        <v-card v-bind:key="item.uid">
      <v-card-text v-if="isLoaded" style="display: block; overflow-wrap: break-word;">
        <v-flex>
        Название: <b>{{item.docName}}</b>
        <v-component :is="renderDepoFileSignature(item)"></v-component>
        </v-flex>
        <v-flex pl-2>
          <span>
          Депонировано: <b>{{formats.blank(item.uploaded, formats.formatDateTime)}}</b> (по:&nbsp{{formats.blank(item.deleted, formats.formatDate)}})
          <v-btn small flat @click="open(item.uid)">Открыть</v-btn>
          </span>
        </v-flex>
      </v-card-text>
        </v-card>
        </template>
    </v-card>

    <template #actions>
      <v-btn v-if="!isEdit" @click="open(fileItem.uid)">Открыть</v-btn>
      <v-component v-if="!isEdit" :is="createCopyButton('Ссылку', 'content_copy', 'Копировать ссылку', copyLink)" />
      <v-spacer v-if="!isEdit"></v-spacer>
      <v-btn v-if="!isEdit" :disabled="readonly || !historyItems || historyItems.length === 0 || historyItems[0].uid.localeCompare(fileItemId) !== 0" @click="edit=true">Атрибуты</v-btn>

      <v-btn v-if="isEdit" @click="save">Сохранить</v-btn>
      <v-spacer v-if="isEdit" ></v-spacer>
      <v-ops-btn v-if="isEdit" :cxt="cxt"></v-ops-btn>

    </template>
</v-btn-form>
</div>
</template>

<script type="text/javascript">
  // import Vue from 'vue'
  import { mapGetters } from 'vuex'
  import dialogs from '../common/dialogs'
  import formats from '../../api/formats'
  import apimix from '../common/apimix'
  import moment from 'moment'
  import vDateField from '../common/DateField.vue'
  import vPanelTitle from '../info/PanelTitle'
  import classes from '../../api/classes'
  import vOpsBtn from '../common/OpsBtn'
  import commons from './index.js'
  import vBtnForm from '../common/BtnForm'

  export default {
    name: 'doc-form',
    components: {vDateField, vPanelTitle, vOpsBtn, vBtnForm},
    mixins: [apimix],
    data: () => ({
      cxt: null,
      edit: false,
      valid: false,
      fileItem: null,
      historyItems: [],
      isLoaded: false,
      fileRule: [v => !!v || 'Выберите файл']
    }),
    props: {
      toolbar: {
        type: Boolean,
        default: false
      },
      fileItemId: {
        type: String,
        default: null
      },
      newPath: {
        type: String,
        default: '/'
      },
      readonly: {
        type: Boolean,
        default: false
      },
      exactVersion: {
        type: Boolean,
        default: false
      }
    },
    created () {
      this.fetchRights()
      this.fetchData(this.fileItemId)
      var cxt = new classes.MultiSelectContext(() => {
        return [this.fileItemId]
      })
      cxt.mode = classes.modes.SELECT
      // cxt.selectActions.push(new classes.Action(this, 'Копировать Ссылку', null,
      //   () => { this.copyLink() }))
      // cxt.selectActions.push(new classes.Action(this, 'Изменить Атрибуты',
      //   () => {
      //     return this.historyItems && this.historyItems.length > 0 && this.historyItems[0].uid.localeCompare(this.fileItemId) === 0
      //   },
      //   () => { this.edit = true }))
      cxt.selectActions.push(new classes.Action(this, 'Загрузить новую версию', null,
        () => this.newVersion()))
      cxt.selectActions.push(new classes.Action(this, 'Заверить электронную копию',
        () => {
          return !(this.fileItem && this.fileItem.signed) && this.getIsAllow({SIGN_FILE: null})
        },
        () => this.signFile([this.fileItem.uid])))
      this.cxt = cxt
    },
    watch: {
      fileItemId: function (newVal, oldVal) { // watch it
        this.fetchData(newVal)
      }
    },
    computed: {
      ...mapGetters({
        getDepoDisplayPaths: 'getDepoDisplayPaths',
        getOpenSettings: 'getOpenSettings',
        getIsAllow: 'getIsAllow',
        getDepoUrl: 'getDepoUrl',
        renderDepoFileSignature: 'renderDepoFileSignature'
      }),
      isEdit () {
        return this.edit
      },
      title () {
        return this.isEdit ? 'Изменить атрибуты депонированного файла' : 'Депонированный файл'
      },
      history () {
        return this.historyItems
      }
    },
    methods: {
      fetchData (itemId) {
        if (itemId) {
          this.$store.dispatch('getDepoFile', itemId).then(
            (fs) => {
              var fileItems = this.exactVersion ? fs.filter(f => f.uid === itemId) : [fs[0]]
              this.fileItem = fileItems && fileItems.length > 0 ? Object.assign({}, fileItems[0]) : Object.assign({}, this.getFileItemNew())
              this.historyItems = fs
            },
            () => {})
        } else {
          this.fileItem = this.getFileItemNew()
        }
      },
      save () {
        this.$store.dispatch('updateDepoFile', this.fileItem)
        this.edit = false
      },
      cancel () {
        this.edit = false
        this.fileItem = Object.assign({}, this.getFileItemNew())
        this.$emit('close')
      },
      newVersion () {
        this.$emit('new-version')
        this.cancel()
      },
      signFile (ids) {
        const fetchData = () => {
          this.fetchData(this.fileItem.uid)
        }
        dialogs.confirm(this,
          'Подтвердите',
          `Заверить электронные копии документов?`,
          (self) => {
            self.$store.dispatch('signDepoFiles', {uids: ids}).then(() => { fetchData() })
          })
        this.edit = false
      },
      open (uid) {
        let url = this.getUrl(uid) + '/stream'
        this.$store.dispatch('openLocation', url)
      },
      getUrl (uid) {
        return this.getDepoUrl(uid)
      },
      getFileItemNew () {
        return {
          uid: null,
          fileNo: null,
          fileName: null,
          fileExt: null,
          fileSize: null,
          docName: null,
          desc: null,
          ownerInn: null,
          ownerNameShort: null,
          account: null,
          uploaded: null,
          path: '//root',
          tags: null,
          folder: null,
          deleted: moment().add(7, 'years').format()
        }
      },
      getDisplayPath (path) {
        return this.getDepoDisplayPaths ? this.getDepoDisplayPaths.get(path) : ''
      },
      getDisplayPaths () {
        var map = this.getDepoDisplayPaths
        var result = []
        if (!map) {
          return result
        }
        map.forEach((val, key) => result.push({key: key, value: val}))
        // console.log('getDisplayPaths', result)
        return result.sort((a, b) => formats.compareString(a.value, b.value))
      },
      copyLink () {
        this.$store.dispatch('copyDepoFileLink', this.getUrl(this.fileItem.uid))
      },
      createCopyButton (caption, icon, hint, action) {
        var template = ''.concat(
          `<div><v-tooltip bottom open-delay="500">
            <div slot="activator">
              <v-btn  @click="action">
                <v-icon small>{{icon}}</v-icon>{{caption}}
              </v-btn>
            </div>
            <span>{{hint}}</span>
          </v-tooltip></div>`
        )
        return {
          template: template,
          data: function () {
            return {
              caption: caption,
              icon: icon,
              hint: hint,
              action: action
            }
          }
        }
      },
      openFile (id) {
        commons.openFile(id, this.getDepoCurrentPath, true, null, true)
      },
      fetchRights () {
        this.$store.dispatch('fetchRights', {SIGN_FILE: null})
      }
    }
  }

</script>




// WEBPACK FOOTER //
// DocForm.vue?23b62bb7